const defaultGist = {
  settings: {
    embed: true,
    sa: 0,
    complete: true,
    paperless: false,
    locale: 'en',
    units: 'metric',
    margin: 2,
    debug: false
  }
}

export default defaultGist
